import "@shoelace-style/shoelace/dist/components/spinner/spinner.js";

import { css, html } from "lit";
import { customElement } from "lit/decorators.js";

import { BaseElement } from "./BaseElement";
import { Style } from "./Styles";

import "./ProgressSpinner/ProgressSpinner";
import { getRandomInt } from "../Utils";

const LOADING_MESSAGES = [
    "Crushing rocks, hold tight",
    "Considering life choices",
    "Getting grubby",
    "Beer or cave, beer or cave",
    "Polishing boots",
    "Plotting and planning",
    "Drying off",
    "Wondering where the snacks are",
    "Why did it go dark",
    "Dreaming of a real bed",
    "This is going to be unpleasant",
    "Does it go to water",
    "Finding wellies",
    "Cleaning equipment",
    "Staying safe",
    "Where to go",
    "Checking out new gear",
    "Can I be clean again yet",
    "Filling cylinders",
    "Finding a buddy",
];

@customElement("ds-loading-screen")
export class LoadingScreen extends BaseElement {
    static override styles = [Style, css``];

    private _message = `${LOADING_MESSAGES[getRandomInt(LOADING_MESSAGES.length)]}...`;

    override render() {
        return html`<ds-progress-spinner .message=${this._message}></ds-progress-spinner>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-loading-screen": LoadingScreen;
    }
}
